import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '../../../../../../../../../components/CiscoUi';

export const IpAddressesTableNoDataAlert = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <Alert>
      {t(
        'sessionsInventory.virtualMachines.ipAddressesTable.noDataToDisplayAlertText',
      )}
    </Alert>
  );
};
